import React from "react";

import { useIntl } from "../../../../shared/core/i18n/use-intl";
import { useAccounts } from "../../../../shared/domains/account/use-accounts";
import { useSelectedAccount } from "../account-transactions/utils/use-selected-account";
import { StatementsPage } from "./components/statements-page";

export default function FeesStatementsScreen() {
  const accounts = useAccounts();
  const [account] = useSelectedAccount(accounts);
  const { formatMessage } = useIntl();

  if (!account) {
    return null;
  }

  return (
    <StatementsPage
      account={account}
      accounts={accounts}
      variant="fee"
      title={formatMessage("myAccountScreen.feesStatement")}
      subtitle={formatMessage("myAccountScreen.feesStatementPageSubtitle")}
      emptyLabel={formatMessage("feesStatements.emptyStatementList")}
    />
  );
}
